import { Reducer, AnyAction, Action } from 'redux';
import { SubscriberGroupsListState } from './types-store';
import {
  ACTION, ClearList,
  RequestList, ReceiveList, FailList,
  UpdateMergeSubscriberGroup,
  RequestSubscriberGroupOptions,
  ReceiveSubscriberGroupOptions,
  FailSubscriberGroupOptions,
  RequestSubscriberGroupItemDelete,
  ReceiveSubscriberGroupItemDelete,
  FailSubscriberGroupItemDelete,
  UpdateValidation,
  ResetValidation
} from './action-types';

export const INITIAL_STATE: SubscriberGroupsListState = {
  requestId: 0,
  fetching: false,
  requestedSearchModel: undefined,
  numberOfResults: undefined,
  listItems: undefined,
  mergeSubscriberGroup: undefined,
  validation: {}
};

const reducers: { [indexer: string]: Reducer<SubscriberGroupsListState, Action> } = {

  [ACTION.CLEAR_LIST]: (state: SubscriberGroupsListState, action: ClearList): SubscriberGroupsListState => {
    return {
      ...state,
      requestId: action.requestId,
      fetching: false,
      requestedSearchModel: undefined,
      numberOfResults: undefined,
      listItems: undefined
    };
  },

  [ACTION.REQUEST_LIST]: (state: SubscriberGroupsListState, action: RequestList): SubscriberGroupsListState => {

    return {
      ...state,
      requestId: action.requestId,
      fetching: true,
      requestedSearchModel: action.model,
      ...(action.clearResults && {
        numberOfResults: undefined,
        listItems: undefined
      })
    };
  },

  [ACTION.RECEIVE_LIST]: (state: SubscriberGroupsListState, action: ReceiveList): SubscriberGroupsListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false,
      numberOfResults: action.numberOfResults,
      listItems: [
        ...(state.listItems || []),
        ...action.list
      ]
    };
  },

  [ACTION.FAIL_LIST]: (state: SubscriberGroupsListState, action: FailList): SubscriberGroupsListState => {

    if (action.requestId !== state.requestId) {
      return state;
    }

    return {
      ...state,
      fetching: false
    };
  },

  [ACTION.UPDATE_MERGE_SUBSCRIBER_GROUP]: (state: SubscriberGroupsListState, 
    action: UpdateMergeSubscriberGroup): SubscriberGroupsListState => {

    return {
      ...state,
      mergeSubscriberGroup: action.mergeSubscriberGroup
    };
  },

  [ACTION.REQUEST_SUBSCRIBER_GROUP_OPTIONS]: (state: SubscriberGroupsListState, 
    action: RequestSubscriberGroupOptions): SubscriberGroupsListState => {
    return {
      ...state,
      subscriberGroupOptions: {
        fetching: true,
        values: []
      }
    };
  },

  [ACTION.RECEIVE_SUBSCRIBER_GROUP_OPTIONS]: (state: SubscriberGroupsListState, 
    action: ReceiveSubscriberGroupOptions): SubscriberGroupsListState => {
    return {
      ...state,
      subscriberGroupOptions: {
        fetching: false,
        values: action.values
      }
    };
  },

  [ACTION.FAIL_SUBSCRIBER_GROUP_OPTIONS]: (state: SubscriberGroupsListState, 
    action: FailSubscriberGroupOptions): SubscriberGroupsListState => {
    return {
      ...state,
      subscriberGroupOptions: {
        fetching: false,
        values: []
      }
    };
  },

  [ACTION.REQUEST_SUBSCRIBER_GROUP_ITEM_DELETE]: (state: SubscriberGroupsListState, 
    action: RequestSubscriberGroupItemDelete): SubscriberGroupsListState => {

    return {
      ...state,
      mergeSubscriberGroup: {
        ...state.mergeSubscriberGroup,
        fetching: true
      }
    };
  },

  [ACTION.RECEIVE_SUBSCRIBER_GROUP_ITEM_DELETE]: (state: SubscriberGroupsListState, 
    action: ReceiveSubscriberGroupItemDelete): SubscriberGroupsListState => {

    return {
      ...state,
      mergeSubscriberGroup: {
        ...state.mergeSubscriberGroup,
        fetching: false
      },
      listItems: state.listItems.filter(item => item.id !== action.id),
      numberOfResults: state.numberOfResults - 1
    };
  },

  [ACTION.FAIL_SUBSCRIBER_GROUP_ITEM_DELETE]: (state: SubscriberGroupsListState, 
    action: FailSubscriberGroupItemDelete): SubscriberGroupsListState => {

    return {
      ...state,
      mergeSubscriberGroup: {
        ...state.mergeSubscriberGroup,
        fetching: false
      }
    };
  },

  [ACTION.UPDATE_VALIDATION]: (state: SubscriberGroupsListState, action: UpdateValidation): SubscriberGroupsListState => {
    return {
      ...state,
      validation: action.validation
    };
  },

  [ACTION.RESET_VALIDATION]: (state: SubscriberGroupsListState, action: ResetValidation): SubscriberGroupsListState => {
    const validation = { ...state.validation, [action.key]: undefined };

    return {
      ...state,
      validation
    };
  }
};

export const reducer: Reducer<SubscriberGroupsListState> = (
  state: SubscriberGroupsListState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};
